const CARD_BG =
  'linear-gradient(180deg, #C2C3C5 -16.4%, #F7F8F8 121.88%), #FFF';

export function PotentialHitSkeleton() {
  return (
    <div
      className="
        aspect-[195/287] animate-pulse
        rounded-[20px] border border-[#EAEAEB]
      "
      style={{ background: CARD_BG }}
      aria-hidden
    />
  );
}
